<template>
  <div>
    <section id="single_draggable">
      <h1>Draggable</h1>
      <hr>
      <div class="uk-card uk-card-default uk-padding">
        <div class="uk-header">
          <h3 class="uk-title">
            Items
          </h3>
          <button
            class="uk-button uk-button-primary"
            @click="insertDragAndDrop"
          >
            insertar en el DragAndDrop
          </button>
        </div>
        <div class="uk-body">
          <div class="line-in-middle">
            <draggable
              v-model="items"
              drop-zone-id="1"
              class="drop-zone"
            >
              <template #item="{item}">
                <div style="margin: 10px">
                  <div
                    class="draggable-item uk-text-center"
                    style="background: red"
                  >
                    <h5 style="font-weight: bold">
                      {{ item.name }}
                    </h5>
                  </div>
                </div>
              </template>
            </draggable>
          </div>
        </div>
      </div>
    </section>

    <section id="multiple_draggable">
      <div class="row">
        <div class="uk-width-1-2">
          <h3>Draggable 1</h3>
          <draggable
            v-model="list1"
            drop-zone-id="1"
            class="drop-zone"
          >
            <template #item="{item}">
              <div style="margin: 10px">
                <div
                  class="draggable-item uk-text-center"
                  style="background: red"
                >
                  <h5 style="font-weight: bold">
                    {{ item.id }} {{ item.name }}
                  </h5>
                </div>
              </div>
            </template>
          </draggable>
        </div>
        <div class="uk-width-1-2">
          <h3>Draggable 2</h3>

          <draggable
            v-model="list2"
            drop-zone-id="2"
            class="drop-zone dragArea list-group"
          >
            <template #item="{item}">
              <div style="margin: 10px">
                <div
                  class="draggable-item uk-text-center"
                  style="background: red"
                >
                  <h5 style="font-weight: bold">
                    {{ item.id }}  {{ item.name }}
                  </h5>
                </div>
              </div>
            </template>
          </draggable>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Draggable from 'vue3-draggable'
export default {
  name: 'ExampleTest',
  components: {
    Draggable
  },
  data () {
    return {
      items: [],
      list1: [
        { name: '1. John', id: 1 },
        { name: '1. Joao', id: 2 },
        { name: '1. Jean', id: 3 },
        { name: '1. Gerard', id: 4 }
      ],
      list2: [
        { name: '2. Juan', id: 5 },
        { name: '2. Edgard', id: 6 },
        { name: '2. Johnson', id: 7 }
      ],
      counter: 5
    }
  },
  watch: {
    list1 (newVal, oldVal) {
      if (newVal.length !== 4) {
        this.counter += 5
        this.list1.pop()
        this.list1.pop()
        this.list1.pop()
        this.list1.pop()
        this.list1.push({ name: '1. John', id: this.counter + 1 })
        this.list1.push({ name: '1. Joao', id: this.counter + 2 })
        this.list1.push({ name: '1. Jean', id: this.counter + 3 })
        this.list1.push({ name: '1. Gerard', id: this.counter + 4 })
      }
    }
  },
  methods: {
    insertDragAndDrop () {
      this.counter += 1
      this.items.push({ id: this.counter, name: 'Field ' + this.counter })
    }
  }
}
</script>

<style scoped>
    .drop-zone {
        background: palevioletred;
        min-height: 100px;
    }

</style>
